import React from "react";

import Header from "../Header";
import MainSection from "./MainSection";
import ReducedSpendSection from "./ReducedSpendSection";
import CurrentRoleSection from "./CurrentRoleSection";
import PlatformSection from "./PlatformSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

export default function CorporateLandingPage() {
  return (
    <>
      <Header />
      <main>
        <MainSection />
        <ReducedSpendSection />
        <CurrentRoleSection />
        <PlatformSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
